import angular from 'angular';
import {
  ssDialogService,
  loaderService,
  reportsDataService,
} from 'app/services';
import {
  alerts,
  actionIcon
} from 'app/components/global';
import controller from './select-report-destination-dialog.controller';
import template from './select-report-destination-dialog.html';


export class dialogService {
  getOptions($event, { reportInstance, destinations }) {
    return {
      controller,
      controllerAs: 'selectReportDestinationDialogVM',
      locals: {
        reportInstance,
        destinations
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.reports.selectReportDestinationDialog', [
  ssDialogService,
  loaderService,
  reportsDataService,
  alerts,
  actionIcon
])
  .service('selectReportDestinationDialog', dialogService)
  .name;

console.log('app.components.reports.selectReportDestinationDialog created');
